import React, { useState } from "react";
import { ThemeColor } from "../../component/theme/color";
import "../login/Login.css";
import {
  Chip,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontSize } from "../../component/theme/fontSize";
import { fontWeight } from "../../component/theme/fontWeight";
import LoginModule from "./Login.module";
import ForgotModule from "./Forgot.module";
import ChangePasswordModule from "./ChangePassword.module";
import SnackbarComponent from "../../component/snackbar/snackbar";
import { useLocation, useNavigate } from "react-router-dom";

function Login(props) {
  // //(props)
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <div
      className="login-container"
      style={{ backgroundColor: ThemeColor.WHITE }}
    >
      <div
        className="side-container"
      >
        <div className="logo px-3 d-flex align-items-center" style={{}}>
          <img src="/assest/Group.png" alt="logo" />
          <img src="assest/Grouptext.png" alt="logo text" className="px-2" />
        </div>
        <div className="side-container-text">
          <Typography
            fontWeight={fontWeight.W700}
            fontSize={fontSize.h2.medium}
            color={ThemeColor.WHITE}
            fontFamily={FontFamily.Nunito}
          >
            We Make Your Work Smarter, Not Harder
          </Typography>
        </div>

        <div className="side-container-chip px-3" style={{ cursor: "pointer" }}>
          <Chip
            label="Check Our Partner Universities"
            sx={{
              backgroundColor: ThemeColor.WHITE,
              color: ThemeColor.RED,
              fontWeight: 700,
              borderRadius: '24px',
              px: 2.5,
              py: 0.6,
              border: `1px solid ${ThemeColor.RED}`,
              boxShadow: '0 6px 18px rgba(232,54,61,0.06)',
              cursor: 'pointer',
              transition: 'transform 0.12s ease, box-shadow 0.12s ease',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 10px 22px rgba(232,54,61,0.10)',
              },
            }}
            onClick={() => (window.location.href = "/partner-university")}
          />
        </div>
      </div>
      <div className="main-container">
        <div className="top-actions">
          {location.pathname === "/partner-university" && (
            <div
              className="login-text"
              onClick={() => {
                navigate("/");
                navigate(0);
              }}
            >
              <Typography
                color={ThemeColor.RED}
                fontWeight={fontWeight.W700}
                fontFamily={FontFamily.Nunito}
                fontSize={fontSize.h3.small}
              >
                Login
              </Typography>
            </div>
          )}

          <div className="privacy-policy">
            <Typography
              color={ThemeColor.RED}
              fontWeight={fontWeight.W700}
              fontFamily={FontFamily.Nunito}
              fontSize={fontSize.h3.small}
            >
              Privacy Policy
            </Typography>
          </div>

          <div className="contact-admin">
            <Typography
              color={ThemeColor.RED}
              fontWeight={fontWeight.W700}
              fontFamily={FontFamily.Nunito}
              fontSize={fontSize.h3.small}
            >
              Contact Admin
            </Typography>
          </div>
        </div>

        {/* branding for screens where the blue side panel is hidden */}
        <div className="mobile-logo">
          <img src="/assest/Group.png" alt="logo" />
          <img src="/assest/Grouptext.png" alt="logo text" />
        </div>

        {props.children}
        {/* <LoginModule /> */}
        {/* <ForgotModule /> */}
        {/* <ChangePasswordModule /> */}
        {/* <div className="privacy-policy">
          <Typography
            color={ThemeColor.RED}
            fontWeight={fontWeight.W700}
            fontFamily={FontFamily.Nunito}
            fontSize={fontSize.h3.small}
            sx={{ textDecoration: "underline" }}
          >
            Privacy Policy
          </Typography>
        </div> */}
      </div>
      <div>
        <SnackbarComponent />
      </div>
    </div>
  );
}

export default Login;
